import React from 'react'

const MDB4Switch = ({
  checked = false,
  className = '',
  disabled = false,
  labelLeft = 'Off',
  labelRight = 'On',
  name,
  getValue,
  onChange,
  ...rest
}) => {
  const handleChange = evt => {
    ;(typeof getValue === 'function' ? getValue : () => {})(evt.target.checked)
    ;(typeof onChange === 'function' ? onChange : () => {})(evt)
  }

  return (
    <div {...rest} className={['switch', className].filter(Boolean).join(' ')} data-test='input-switch'>
      <label>
        {labelLeft}
        <input type='checkbox' name={name} disabled={disabled} checked={!!checked} onChange={handleChange} />
        <span className='lever' />
        {labelRight}
      </label>
    </div>
  )
}

export default MDB4Switch
